"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var rxjs_1 = require("rxjs");
// eslint-disable-next-line import/no-extraneous-dependencies
var operators_1 = require("rxjs/operators");
var react_2 = require("@fluentui/react");
var react_transition_group_1 = require("react-transition-group");
var clsx_1 = __importDefault(require("clsx"));
var uniqueId_1 = require("../../helpers/uniqueId");
var _1 = require(".");
require("./LayoutNotificationArea.scss");
var LayoutNotificationPlacement;
(function (LayoutNotificationPlacement) {
    LayoutNotificationPlacement["topRight"] = "position-top-right";
    LayoutNotificationPlacement["bottomRight"] = "position-bottom-right";
})(LayoutNotificationPlacement = exports.LayoutNotificationPlacement || (exports.LayoutNotificationPlacement = {}));
var NotificationActionType;
(function (NotificationActionType) {
    NotificationActionType[NotificationActionType["add"] = 0] = "add";
    NotificationActionType[NotificationActionType["remove"] = 1] = "remove";
    NotificationActionType[NotificationActionType["removeAll"] = 2] = "removeAll";
})(NotificationActionType || (NotificationActionType = {}));
exports.LayoutNotificationArea = function (props) {
    var children = props.children, placementProps = props.placement, maxNotificationsDisplayedProps = props.maxNotificationsDisplayed, notificationDuration = props.notificationDuration;
    var notificationSubject = react_1.useRef(new rxjs_1.Subject());
    var maxNotificationsDisplayed = react_1.useState(maxNotificationsDisplayedProps !== null && maxNotificationsDisplayedProps !== void 0 ? maxNotificationsDisplayedProps : 5)[0];
    var allNotifications = react_1.useRef([]);
    var _a = react_1.useState([]), notifications = _a[0], setNotifications = _a[1];
    var _b = react_1.useState(), placement = _b[0], setPlacement = _b[1];
    react_1.useEffect(function () {
        setPlacement(placementProps !== null && placementProps !== void 0 ? placementProps : LayoutNotificationPlacement.bottomRight);
    }, [placementProps]);
    var processNext = react_1.useCallback(function (next) {
        if ((next === null || next === void 0 ? void 0 : next.length) > 0) {
            var allNotifs_1 = allNotifications.current;
            var removedNotifications_1 = [];
            next.forEach(function (action) {
                if (action.actionType === NotificationActionType.add && action.notificationInfo && action.notificationKey) {
                    allNotifs_1.push(__assign(__assign({}, action.notificationInfo), { notificationKey: action.notificationKey }));
                }
                else if (action.actionType === NotificationActionType.remove) {
                    var notificationIndex = allNotifs_1.findIndex(function (n) { return n.notificationKey === action.notificationKey; });
                    if (notificationIndex > -1) {
                        removedNotifications_1.push(allNotifs_1[notificationIndex]);
                        allNotifs_1.splice(notificationIndex, 1);
                    }
                }
                else {
                    var removed = allNotifs_1.splice(0, 5);
                    removedNotifications_1.push.apply(removedNotifications_1, removed);
                }
            });
            setNotifications(allNotifications.current.slice(0, maxNotificationsDisplayed));
            removedNotifications_1.forEach(function (removed) {
                if (removed.onDismissed) {
                    removed.onDismissed();
                }
            });
        }
    }, [maxNotificationsDisplayed]);
    react_1.useEffect(function () {
        var subject = notificationSubject.current;
        subject
            .pipe(operators_1.bufferTime(300))
            .subscribe(processNext);
        return function () { return subject === null || subject === void 0 ? void 0 : subject.unsubscribe(); };
    }, [processNext]);
    var addNotification = function (notification) {
        var key = uniqueId_1.generateUniqueId();
        notificationSubject.current.next({
            actionType: NotificationActionType.add,
            notificationKey: key,
            notificationInfo: notification
        });
        return key;
    };
    var removeNotification = function (notificationKey) {
        notificationSubject.current.next({
            actionType: NotificationActionType.remove,
            notificationKey: notificationKey
        });
    };
    var removeAllNotifications = function () {
        notificationSubject.current.next({
            actionType: NotificationActionType.removeAll
        });
    };
    var layoutNotificationsClassName = clsx_1.default('eta-layout-notification-area', placement);
    return (react_1.default.createElement(_1.LayoutNotificationContext.Provider, { value: { addNotification: addNotification, removeNotification: removeNotification, removeAllNotifications: removeAllNotifications } },
        children,
        react_1.default.createElement(react_2.Layer, null,
            react_1.default.createElement(react_transition_group_1.TransitionGroup, { className: layoutNotificationsClassName }, notifications === null || notifications === void 0 ? void 0 : notifications.map(function (notification) { return (react_1.default.createElement(react_transition_group_1.CSSTransition, { key: notification.notificationKey, timeout: 300 },
                react_1.default.createElement(_1.LayoutNotification, __assign({}, notification, { duration: notificationDuration, onDismissed: function () { return removeNotification(notification.notificationKey); } })))); })))));
};
//# sourceMappingURL=LayoutNotificationArea.js.map